// extracted by mini-css-extract-plugin
export default {"header":"style_header__BuS7A","ticketsList":"style_ticketsList__Q3MAl","filtersContainer":"style_filtersContainer__kYVDO"};